import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class HelpNavigation extends Vue {
    @Prop() route!: any;
}
